var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFilledCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66797C5.40033 1.66797 1.66699 5.4013 1.66699 10.0013C1.66699 14.6013 5.40033 18.3346 10.0003 18.3346C14.6003 18.3346 18.3337 14.6013 18.3337 10.0013C18.3337 5.4013 14.6003 1.66797 10.0003 1.66797ZM7.74199 13.5763L4.75033 10.5846C4.42533 10.2596 4.42533 9.73464 4.75033 9.40964C5.07533 9.08464 5.60033 9.08464 5.92533 9.40964L8.33366 11.8096L14.067 6.0763C14.392 5.7513 14.917 5.7513 15.242 6.0763C15.567 6.4013 15.567 6.9263 15.242 7.2513L8.91699 13.5763C8.60033 13.9013 8.06699 13.9013 7.74199 13.5763Z",
    fill: "#66BB6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilledCircle);
export default __webpack_public_path__ + "static/media/CheckFilledCircle.29884ad930eb9f650d23119cad61eb46.svg";
export { ForwardRef as ReactComponent };